import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";

const ThemSuaHangSanXuat = ({ onClose, onSave, data, listCauHinhTaiSan }) => {
    //console.log("Data: ", data);
    const [LoaiTaiSanID, setLoaiTaiSanID] = useState(data?.CauHinhTaiSanId??listCauHinhTaiSan[0]?.CauHinhTaiSanId);
    const [TenHangSanXuat, setTenHangSanXuat] = useState(data?.TenHangSanXuat ?? "");
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    const handleKeyDown = (event) => {
        if (event.key === "Escape") onClose();
    };
    useEffect(() => {

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
    const validate = () => {
        let newErrors = {};
        if (!TenHangSanXuat.trim()) newErrors.TenHangSanXuat = "Hãy nhập tên hãng sản xuất";
        return newErrors;
    };
    const handleSave = async () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setSaving(true);
        try {
            const payload = {
                ThongTinGiamTruID: data?.ThongTinGiamTruID ?? 0,
                ThongTinGiamTruPID: 0,
                LoaiTaiSanID: parseInt(LoaiTaiSanID),
                TenHangSanXuat: TenHangSanXuat.trim(),
                KeyThongTinGiamTru: data?.KeyThongTinGiamTru ?? "",
                isDel: data?.isDel ?? true
            };
            // console.log("datasave payload: ", payload);
            await onSave(payload);
        }
        catch (err) {
            console.error("Lỗi khi lưu:", err);
            pushNotification("Có lỗi xảy ra khi lưu. Vui lòng thử lại.", "error", "TOP_CENTER", 1000);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            show={true}
            size="lg"
            centered
            className="modal-new modal fade text-left"
            animation={true}
        >
            <Modal.Header>
                <h4 className="modal-title text-bold" style={{ paddingLeft: "15px" }}>
                    {(!data?.ThongTinGiamTruID || data.ThongTinGiamTruID === 0) ? "Thêm mới hãng sản xuất" : "Sửa hãng sản xuất"}
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="row" style={{ paddingTop: "5px" }}>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label><span className="text-bold">Loại tài sản</span></label>
                            <select id="LoaiTaiSanID" name="LoaiTaiSanID"
                                value={LoaiTaiSanID}
                                onChange={(e) => setLoaiTaiSanID(e.target.value)}
                                className="form-control input-sm">
                                {listCauHinhTaiSan && listCauHinhTaiSan.map((cauhinh, index) => (
                                    <option key={index} value={cauhinh.CauHinhTaiSanId}>
                                        {cauhinh.TenHangHoa}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label><span className="text-bold">Tên hãng sản xuất</span><span className="text-danger">(*)</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={TenHangSanXuat}
                                onChange={(e) => setTenHangSanXuat(e.target.value)}
                                placeholder="Ví dụ: Honda"
                            />
                            {errors.TenHangSanXuat && <div className="text-danger">{errors.TenHangSanXuat}</div>}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-new-main btn-closenew" onClick={onClose} disabled={saving}>
                    <i className="mdi mdi-close"></i>&nbsp; Đóng
                </button>
                <button className="btn " onClick={handleSave} disabled={saving} style={{ background: "#056569", color: "white", borderRadius: "6px", fontSize: "15px", textTransform: "none" }}>
                    {saving ? (
                        <>
                            <span className="spinner-border spinner-border-sm"></span>&nbsp; Đang lưu...
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-content-save"></i>&nbsp; Lưu
                        </>
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
}




export default ThemSuaHangSanXuat;